
































import Vue from 'vue'
import _ from 'lodash'
import { QcqCommonGridItem } from '@/types'

interface ComponentData {
  selectedCompetence: QcqCommonGridItem | undefined
  filteredCompetencesList: Array<QcqCommonGridItem>
  competenceValidationRules: Array<Function>
}

export default Vue.extend({
  name: 'CompetenceDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object as () => QcqCommonGridItem
    },
    competenceList: {
      type: Array as () => Array<QcqCommonGridItem>
    },
    selectedCompetenceList: {
      type: Array as () => Array<QcqCommonGridItem>
    },
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('errors.required').toString()

    return {
      selectedCompetence: undefined,
      filteredCompetencesList: [],
      competenceValidationRules: [
        required
      ]
    }
  },

  watch: {},

  computed: {},

  methods: {

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        this.$emit('save', this.selectedCompetence)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    }
  },

  mounted (): void {
    let list: Array<QcqCommonGridItem> = []
    this.competenceList.forEach((item: QcqCommonGridItem) => {
      if (!this.selectedCompetenceList.includes(item)) {
        list.push(item)
      }
    })
    if(this.dialogData) {
      list.push(this.dialogData)
      this.selectedCompetence = this.dialogData
    }
    this.filteredCompetencesList = _.sortBy(list,  [i => i.description.toLowerCase()])

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
